<div class="kt-header__topbar">

	<div class="kt-header__topbar-item help" ngbDropdown placement="bottom-right" ngbTooltip="Help">
		<div class="kt-header__topbar-wrapper" ngbDropdownToggle>
			<span
				class="kt-header__topbar-icon kt-pulse kt-pulse--brand position-relative nohover brand-config-color-hover">
				<svg-icon class="svg_icon17x17 d-inline" src="assets/media/iq-svg/without_circle/icon_set_4/Help.svg"></svg-icon>
			</span>
		</div>
		<div class="dropdown-menu-fit dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl" ngbDropdownMenu>
			<div class="kt-grid-nav border-bottom">
				<div class="kt-grid-nav__row">

					<a href="https://links.iqcheckpoint.com/yt-web"
						class="kt-grid-nav__item dropdown-item support-width-50" target="_blank">
						<span class="kt-grid-nav__icon">
							<!-- <img src="assets/media/icons/with-opacity/tutorial.svg" alt="" height="60"> -->
							<svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/tutorial.svg"></svg-icon>
						</span>
						<span class="kt-grid-nav__title">Tutorial</span>
					</a>

					<a href="https://updates.iqcheckpoint.com/iqcheckpoint/kb"
						class="kt-grid-nav__item dropdown-item support-width-50" target="_blank">
						<span class="kt-grid-nav__icon">
							<!-- <img src="assets/media/icons/with-opacity/help_guide.svg" alt="" height="60"> -->
							<svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/help_guide.svg"></svg-icon>
						</span>
						<span class="kt-grid-nav__title">Help Guide</span>
					</a>

				</div>
				<div class="kt-grid-nav__row">

					<a href="https://updates.iqcheckpoint.com/iqcheckpoint#/ideas"
						class="kt-grid-nav__item dropdown-item support-width-50" target="_blank">
						<span class="kt-grid-nav__icon">
							<!-- <img src="assets/media/icons/with-opacity/share_idea.svg" alt="" height="60"> -->
							<svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/share_idea.svg"></svg-icon>
						</span>
						<span class="kt-grid-nav__title">Share Your Ideas</span>
					</a>

					<a href="javascript:void(0);" class="kt-grid-nav__item dropdown-item support-width-50"
						(click)="displayFreshchatWidget ? closeChat(true) : openChat()">
						<span class="kt-grid-nav__icon">
							<!-- <img src="assets/media/icons/with-opacity/chat_support_show.svg" alt="" height="60"> -->
							<svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/chat_support_show.svg"></svg-icon>
						</span>
						<!-- Change label: Hide-Show -->
						<span class="kt-grid-nav__title">Chat Support <small>({{ displayFreshchatWidget ? 'Hide': 'Show'
								}})</small></span>
					</a>
				</div>

			</div>

			<div class="text-center px-3 py-5">
				<div class="h6">Let's talk!</div>
				<a href="mailto:support@iqcheckpoint.com"
					class="kt-font-brand fw-bold">support&#64;iqcheckpoint.com</a>
			</div>

		</div>
	</div>

	<div class="separator-v"></div>

	<div ngbDropdown placement="bottom-right" class="kt-header__topbar-item kt-header__topbar-item--user">
		<div ngbDropdownToggle class="kt-header__topbar-wrapper">

			<a class="">
				<img *ngIf="user?.user_profile_url" alt="Pic" height="35" width="35" class="rounded-circle"
					[src]="user?.user_profile_url">
			</a>

			<span *ngIf="!user?.user_profile_url" style="margin-right: 5px;background-color: lightgrey;"
				class="kt-header__topbar-icon">
				<div class="rounded-circle media-size">
					{{(user?.user_first_name?.toUpperCase() + ' ' + user?.user_last_name?.toUpperCase()) | firstLetter}}
				</div>
			</span>
			<span *ngIf="badge" class="kt-header__topbar-icon">
				<b>{{(user?.user_first_name + ' ' + user?.user_last_name) | firstLetter}}</b>
			</span>
		</div>
		<div ngbDropdownMenu
			class="dropdown-menu dropdown-menu-fit dropdown-menu-end dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
			<!--begin: Head -->
			<div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
				style="background-image: url(./assets/media/misc/bg-1.jpg)">
				<div class="kt-user-card__name">
					{{(user?.user_first_name + ' ' + user?.user_last_name)}}
				</div>

			</div>
			<!--end: Head -->

			<!--begin: Navigation -->
			<div class="kt-notification">
				<a ngbDropdownItem href="javascript:;" class="kt-notification__item" (click)="editUserInfo()">
					<div class="kt-notification__item-icon">
						<svg-icon class="svg_icon22x22 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/edit.svg"></svg-icon>
					</div>
					<div class="kt-notification__item-details">
						<div class="kt-notification__item-title kt-font-bold">
							Edit User Info
						</div>
						<div class="kt-notification__item-time" style="white-space: normal;">
							Edit User Information like First Name, Last Name, Profile Image etc.
						</div>
					</div>
				</a>
				<div class="kt-notification__custom">
					<a href="javascript:;" (click)="logout()"
						class="btn btn-outline-brand btn-upper btn-sm btn-bold">Sign
						Out</a>

				</div>
				<!--end: Navigation -->
			</div>
		</div>
	</div>
</div>